import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ILightWeightObject, ILocalSearchDataItemModel } from '@fi-shared/models';
import { IObjectDto } from '@fi-shared/models/models';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'data-field-view-business-areas',
    templateUrl: './business-areas.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewBusinessAreasComponent extends FiDataFieldViewBase {
    FiStateNames = FiStateNames;

    get isNotEmpty() {
        return this.dataFieldObject.BusinessAreas && this.dataFieldObject.BusinessAreas.length > 0;
    }

    getSearchObjects(businessArea: ILightWeightObject): [ILocalSearchDataItemModel] {
        return [
            {
                Id: businessArea.Id,
                ObjectType: ObjectTypes.BusinessArea,
                Name: businessArea.Name,
            },
        ];
    }
}
